'use strict';

const BaseScene = require('./base-scene');
const Button = require('../ui/button');
const { COLORS, GAME_WIDTH, MAX_LEVEL } = require('../config/constants');
const { drawGlowText, drawText } = require('../ui/draw');

const LEVELS_PER_PAGE = 15;

class LevelSelectScene extends BaseScene {
  enter(payload) {
    const requestedPage = payload && Number.isInteger(payload.page) ? payload.page : 0;
    this.page = Math.max(0, Math.min(this.totalPages() - 1, requestedPage));
    this.buildButtons();
  }

  totalPages() {
    return Math.ceil(MAX_LEVEL / LEVELS_PER_PAGE);
  }

  buildButtons() {
    const buttons = [];
    const start = this.page * LEVELS_PER_PAGE + 1;
    for (let index = 0; index < LEVELS_PER_PAGE; index += 1) {
      const level = start + index;
      if (level > MAX_LEVEL) break;
      const column = index % 3;
      const row = Math.floor(index / 3);
      const unlocked = level <= this.app.profile.highestUnlockedLevel;
      buttons.push(new Button({
        x: 82 + column * 204,
        y: 280 + row * 145,
        width: 178,
        height: 104,
        label: String(level),
        disabled: !unlocked,
        variant: level === this.app.profile.highestUnlockedLevel ? 'primary' : 'secondary',
        fontSize: 36,
        onTap: () => this.app.switchScene('game', { level })
      }));
    }
    buttons.push(new Button({
      x: 70,
      y: 1065,
      width: 180,
      height: 78,
      label: '上一页',
      variant: 'secondary',
      disabled: this.page === 0,
      onTap: () => {
        this.page -= 1;
        this.buildButtons();
      }
    }));
    buttons.push(new Button({
      x: 285,
      y: 1065,
      width: 180,
      height: 78,
      label: '返回',
      variant: 'secondary',
      onTap: () => this.app.switchScene('home')
    }));
    buttons.push(new Button({
      x: 500,
      y: 1065,
      width: 180,
      height: 78,
      label: '下一页',
      variant: 'secondary',
      disabled: this.page >= this.totalPages() - 1,
      onTap: () => {
        this.page += 1;
        this.buildButtons();
      }
    }));
    this.buttons = buttons;
  }

  render(ctx) {
    drawGlowText(ctx, '选择关卡', GAME_WIDTH / 2, 145, 58, COLORS.cyan);
    drawText(
      ctx,
      `已解锁 ${this.app.profile.highestUnlockedLevel} / 99`,
      GAME_WIDTH / 2,
      215,
      27,
      COLORS.muted
    );
    this.drawButtons(ctx);
    drawText(
      ctx,
      `${this.page + 1} / ${this.totalPages()}`,
      GAME_WIDTH / 2,
      1195,
      25,
      COLORS.muted
    );
  }
}

module.exports = LevelSelectScene;

